import { Font } from '@react-pdf/renderer';
import { Noto } from 'PDF/fonts';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSection } from 'store/useBusinessToolStore/selectors';

import { LastPage } from '../LastPage';
import { useCanAccessSectionMap } from './utils';

Font.getRegisteredFonts();
Font.register(Noto);

interface IProps {
  saveSectionProps: (key: string, props: Record<string, any>) => void;
}

export const TableOfContents = ({ saveSectionProps }: IProps) => {
  const activeSection = useBusinessToolStore(getActiveSection);
  const canAccessSectionMap = useCanAccessSectionMap({ saveSectionProps });

  return (
    <>
      {canAccessSectionMap.get(activeSection)}
      <LastPage saveSectionProps={saveSectionProps} />
    </>
  );
};
